import { BaseFilterModel, DataGridFilter } from '../create-data-grid-filter';

export const rangeDateFilterModelName = 'range_date_filter';

type RangeDateFilterValue = { start: Date; end: Date };

export type RangeDateFilterModel = BaseFilterModel<
  RangeDateFilterValue,
  typeof rangeDateFilterModelName
>;

export type RangeDateFilterParams = {
  /**
   * The name of the field for filtering in the server-side API
   */
  filterName: string;
  closeWhenChanged?: boolean;
  placeholder?: string;
};

type CreateRangeDateFilterModelParams = {
  value: RangeDateFilterValue;
  filterName: string;
};

export type RangeDateDataGridFilter = DataGridFilter<
  RangeDateFilterParams,
  RangeDateFilterModel
>;

export const createRangeDateFilterModel = ({
  value,
  filterName,
}: CreateRangeDateFilterModelParams): RangeDateFilterModel => {
  return {
    filterModelName: rangeDateFilterModelName,
    value,
    filterName,
  };
};
